module.exports = __webpack_public_path__ + "static/img/yingxiao.a2d3ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-activity/yingxiao.png
// module id = 295
// module chunks = 0